export const deepCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}